var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.9 44.2",
    enableBackground: "new 0 0 30.9 44.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M25.7,16.5c-0.6,0-1-0.4-1-1V11c0-5-4-9-9-9H15c-5,0-9,4-9,9v4.3c0,0.6-0.4,1-1,1s-1-0.4-1-1V11 C4,4.9,8.9,0,15,0h0.7c6.1,0,11,4.9,11,11v4.5C26.7,16,26.2,16.5,25.7,16.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M15.4,44.2C6.9,44.2,0,37.3,0,28.8V15.5c0-0.6,0.4-1,1-1h28.9c0.6,0,1,0.4,1,1v13.3 C30.9,37.3,23.9,44.2,15.4,44.2z M2,16.5v12.3c0,7.4,6,13.4,13.4,13.4c7.4,0,13.4-6,13.4-13.4V16.5H2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M15.5,30.6c-2.2,0-4.1-1.8-4.1-4.1c0-2.2,1.8-4.1,4.1-4.1c2.2,0,4.1,1.8,4.1,4.1 C19.5,28.7,17.7,30.6,15.5,30.6z M15.5,24.4c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1S16.6,24.4,15.5,24.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M15.5,35.4c-0.5,0-1-0.6-1-1.1l0-3.2c0-0.6,0.4-1,1-1.1c0.6,0,1,0.4,1,1l0,3.3C16.5,34.8,16,35.4,15.5,35.4 C15.5,35.4,15.5,35.4,15.5,35.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.099e3ba6fcbe8cd7c16378348cf91963.svg";
export { ForwardRef as ReactComponent };